/**
 * Sort-direction preference (card-preferences design § A): a per-viewer, client-only display
 * opinion, not a game fact — the server always sends canonical ascending order
 * (`rules/CardComparator`), and reversing it is an involution, not a re-sort. Applied at the two
 * decode boundaries (`serde/decode-wire-state.js`, `serde/decode-round-record.js`), never at
 * render or in the rules/session layer, so decoded state order stays displayed order everywhere.
 * No URL override (YAGNI) — mirrors `card-style.js`'s localStorage shape without the dev
 * play-test lever, which this pref has no use for.
 *
 * `sortDescending()` is reached from a second, non-browser runtime: `serde/decode-wire-state.js`
 * and `serde/decode-round-record.js` are also imported directly by `scripts/agent/state-summary.js`
 * / `round-record-summary.js` (the agent CLI's own decode, run under plain Node — no jsdom, no
 * `localStorage`). A Node CLI reader has no viewer preference, so it degrades to `false`
 * (ascending, the pre-existing behavior there) rather than throwing.
 */
export function sortDescending() {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem("sortDescending") === "true";
}

export function setSortDescending(value) {
  localStorage.setItem("sortDescending", value ? "true" : "false");
}
